/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Plug_TitleInputs */

const en_directory_footer_plug_title = /** @type {(inputs: Directory_Footer_Plug_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Access`)
};

const zh_directory_footer_plug_title = /** @type {(inputs: Directory_Footer_Plug_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 接口`)
};

/**
* | output |
* | --- |
* | "AI Access" |
*
* @param {Directory_Footer_Plug_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_plug_title = /** @type {((inputs?: Directory_Footer_Plug_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Plug_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_plug_title(inputs)
	return zh_directory_footer_plug_title(inputs)
});
export { directory_footer_plug_title as "directory.footer.plug_title" }